import { Check } from "untitledui-js/react";

import { DropdownMenu, DropdownMenuItem } from "@components/DropdownMenu";
import { type AutoTranslateLanguage } from "../../types/StoryblokTypes";

export const AUTO_TRANSLATE_LANGUAGE_OPTIONS: readonly {
  code: AutoTranslateLanguage;
  label: string;
}[] = [
  { code: "nl", label: "Nederlands" },
  { code: "en", label: "English" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "de", label: "Deutsch" },
  { code: "lt", label: "Lietuvių" },
  { code: "pt", label: "Português" },
  { code: "es", label: "Español" },
];

interface AutoTranslateLanguageMenuProps {
  isOpen: boolean;
  id: string;
  language: AutoTranslateLanguage | null;
  onSelect: (code: AutoTranslateLanguage) => void;
  className?: string;
}

export const AutoTranslateLanguageMenu = ({
  isOpen,
  id,
  language,
  onSelect,
  className,
}: AutoTranslateLanguageMenuProps) => {
  return (
    <DropdownMenu isOpen={isOpen} id={id} className={className}>
      {AUTO_TRANSLATE_LANGUAGE_OPTIONS.map(({ code, label }) => (
        <DropdownMenuItem
          key={code}
          aria-current={language === code ? "true" : undefined}
          onClick={() => onSelect(code)}
        >
          <span className="flex-1 text-left">{label}</span>
          {language === code && <Check width={16} />}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
